// extracted by mini-css-extract-plugin
export default {"redirect_parent":"styles_redirect_parent__WG4eA"};